




import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import { debounce } from "@/utils";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  MeterChartDatas,
  MeterChartData,
  Echartlegend,
} from "@/api/baseDefine";

@Component
export default class MeterLineChart extends Vue {
  public 0;
  @Prop({ default: "chart" }) private className!: string;
  @Prop({ default: "100%" }) private width!: string;
  @Prop({ default: "350px" }) private height!: string;
  @Prop({ default: "true" }) private autoResize!: boolean;
  @Prop({ required: true }) private chartData!: MeterChartDatas;
  @Prop({ default: "" }) private unit!: any;
  private chart: echarts.ECharts | undefined = undefined;
  private sidebarElm: Element | undefined = undefined;
  private haveLeftFlag = false;
  private colors = ["#5793f3", "#d14a61"];

  public onChangeValue(val: MeterChartDatas) {
    this.setOptions(val);
  }

  public setOptions(showData: MeterChartDatas) {
    if (!this.chart) {
      return;
    }

    if (!showData) {
      return;
    }
    this.haveLeftFlag = false;
    let option = this.getOption(showData);
    console.log("setOptions-----------------------------------", option);
    this.chart.setOption(option, true);
  }

  private getOption(showData: MeterChartDatas) {
    let option: echarts.EChartOption = <echarts.EChartOption>{};
    let yAxisArray: echarts.EChartOption.YAxis[] = [];
    let seriesArray: echarts.EChartOption.Series[] = [];
    option.series = seriesArray;
    option.yAxis = yAxisArray;
    option.color = [];
    option.xAxis = <echarts.EChartOption.XAxis>{
      data: showData.xDatas,
      boundaryGap: true,
      axisTick: {
        show: false,
      },
    };
    let legend = <Echartlegend>{
      data: [],
    };
    if (!!showData.leftDatas && showData.leftDatas.length > 0) {
      let yAxis: echarts.EChartOption.YAxis = <echarts.EChartOption.YAxis>{
        type: "value",
        position: "left",
        name: showData.leftName,
        // axisLine: {
        //   lineStyle: {
        //     color: this.colors[0],
        //   },
        // },
        axisLabel: {
          formatter: "{value} " + showData.leftUnit,
        },
      };

      option.yAxis.push(yAxis);
      this.haveLeftFlag = true;
      for (let i = 0; i < showData.leftDatas.length; i++) {
        legend.data.push(showData.leftDatas[i].name);
        this.addOption(
          showData.leftDatas[i],
          option,
          true,
          showData.leftDatas.length == 1
        );
      }
      option.color.push(this.colors[0]);
    }
    if (!!showData.rightDatas && showData.rightDatas.length > 0) {
      let yAxis: echarts.EChartOption.YAxis = <echarts.EChartOption.YAxis>{
        type: "value",
        position: "right",
        name: showData.rightName,
        // axisLine: {
        //   lineStyle: {
        //     color: this.colors[1],
        //   },
        // },
        axisLabel: {
          formatter: "{value} " + showData.rightUnit,
        },
      };
      legend.data.push(showData.rightName);
      option.yAxis.push(yAxis);
      for (let i = 0; i < showData.rightDatas.length; i++) {
        legend.data.push(showData.rightDatas[i].name);
        this.addOption(showData.rightDatas[i], option, false, false);
      }
      option.color.push(this.colors[1]);
    }
    option.legend = legend;
    return option;
  }

  private addOption(
    data: MeterChartData,
    option: echarts.EChartOption,
    left: boolean,
    bar: boolean
  ) {
    let position = left ? "left" : "right";
    let yAxisIndex = left ? 0 : 1;
    if (!this.haveLeftFlag) {
      yAxisIndex = 0;
    }
    let type = bar ? "bar" : "line";
    let color = left ? this.colors[0] : this.colors[1];

    let series: echarts.EChartOption.Series = <echarts.EChartOption.Series>{
      barMaxWidth: "60px",
      name: data.name,
      // itemStyle: {
      //   normal: {
      //     color: "#409EFF",
      //     lineStyle: {
      //       color: "#409EFF",
      //       width: 2,
      //     },
      //   },
      // },
      yAxisIndex: yAxisIndex,
      smooth: false,
      type: type,
      data: data.yDatas,
      animationDuration: 0,
      animationEasing: "cubicInOut",
    };
    if (option.series != undefined) {
      option.series.push(series);
    }

    return option;
  }
  private getBarOption(data: MeterChartData, xDatas: string[]) {
    return {
      xAxis: {
        data: xDatas,
        boundaryGap: true,
        axisTick: {
          show: false,
        },
      },
      yAxis: [
        {
          type: "value",
          name: data.name,
          axisLabel: {
            formatter: "{value}" + " " + this.unit,
          },
        },
      ],
      legend: {
        data: ["expected"],
      },
      series: [
        {
          barMaxWidth: "60px",
          name: data.name,
          itemStyle: {
            normal: {
              color: "#409EFF",
              lineStyle: {
                color: "#409EFF",
                width: 2,
              },
            },
          },
          // yAxisIndex: 1,
          smooth: false,
          type: "bar",
          data: data.yDatas,
          animationDuration: 0,
          animationEasing: "cubicInOut",
        },
      ],
    };
  }

  private getLineOption(datas: MeterChartData[], xDatas: string[]) {
    let series: any[] = [];
    for (let i = 0; i < datas.length; i++) {
      let s: any = {
        name: "" + i,
        smooth: false,
        type: "line",
        data: datas[i].yDatas,
        animationDuration: 0,
        animationEasing: "cubicInOut",
      };
      series.push(s);
    }
    return {
      xAxis: {
        data: xDatas,
        boundaryGap: true,
        axisTick: {
          show: false,
        },
      },
      yAxis: [
        {
          type: "value",
          name: "right",
          axisLabel: {
            formatter: "{value}" + " " + this.unit,
          },
        },
        // {
        //   type: "value",
        //   name: "reading"
        // }
      ],
      legend: {
        data: ["expected"],
      },
      series: series,
    };
  }

  public initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, "macarons");
    this.setOptions(this.chartData);
  }

  public mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.__resizeHandler);
    }
    // 监听侧边栏的变化
    this.sidebarElm = document.getElementsByClassName("sidebar-container")[0];
    this.sidebarElm &&
      this.sidebarElm.addEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
  }

  /**
   * name
   */
  public __resizeHandler() {
    debounce(
      () => {
        if (this.chart) {
          this.chart.resize();
        }
      },
      100,
      false
    );
  }

  public beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }

    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );

    this.chart.dispose();
    this.chart = undefined;
  }

  public sidebarResizeHandler(e) {
    if (e.propertyName === "width") {
      this.__resizeHandler();
    }
  }
}
